<!--
  组件说明：分类树编辑组件
  调用示范：
  <el-dialog title="编辑分类" :visible.sync="showDialog" width="40%" center>
    <classifyTreeEdit type="questions" :visible.sync="showDialog"></classifyTreeEdit>
  </el-dialog>
-->
<template>
  <div>
    <div>
      <el-button type="text" @click="addRootNode" style="font-size: 14px;">
        <i class="el-icon-plus" style="margin-right:5px"></i>添加一级分类
      </el-button>
      <span style="margin-left: 20px; color: red; font-size: 13px">管理员创建"一级分类"时，应以"条线或部门"规范命名</span>
    </div>
    <div ref="treectn01" :style="`height: ${treeHeight}; overflow: auto;`">
      <!-- <div :style="`height: ${treeHeight};`"> -->
        <el-tree
          :data="data"
          node-key="flbh"
          default-expand-all
          ref="tree"
          :props="defaultProps"
          :expand-on-click-node="false">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <!-- 如果是添加、编辑状态 -->
            <el-input v-if="data.zt === '1' || data.zt === '2'"
              :class="'myInput input' + node.id" v-model="data.flmc"></el-input>
            <!-- 如果是删除状态 -->
            <s v-else-if="data.zt === '3'" v-text="data.flmc"></s>
            <!-- 正常状态 -->
            <span v-else v-text="data.flmc"></span>
            <span>
              <el-button type="text" size="mini"
                @click="() => editNode(node,data)"> 编辑 </el-button>
              <el-button type="text" size="mini"
                @click="() => addNode(node,data)"> 添加 </el-button>
              <el-button type="text" size="mini"
                @click="() => beforeDelete(node, data)"> 删除 </el-button>
            </span>
          </span>
        </el-tree>
      <!-- </div> -->
    </div>
    <!-- <div style="margin-bottom: -10px;">
        <el-divider></el-divider>
    </div> -->
    <br>
    <div class="buttons" style="text-align:center;">
      <el-button type="warning" @click="submit">保存修改</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>
<script>
import { getClassifyList as examClassify, checkExistsData as checkExamData, saveClassify as saveExamClassify } from '@/api/exam'
import { getClassifyList as examPaperClassify, checkExistsData as checkExamPaperData, saveClassify as saveExamPaperClassify } from '@/api/examPaper'
import { getClassifyList as questionsClassify, checkExistsData as checkQuestionsData, saveClassify as saveQuestionsClassify } from '@/api/questions'
export default {
  data () {
    return {
      dataCount: 1,
      list: [],
      data: [],
      defaultProps: {
        children: 'children',
        label: 'flmc'
      }
    }
  },
  props: {
    type: String,
    visible: Boolean,
    treeHeight: {
      type: String,
      default: () => { return '400px' }
    }
  },
  methods: {
    addRootNode () {
      const newChild = {
        zt: '1',
        flbh: 'XN' + this.$utils.getUUID(), // 虚拟一个分类编号 该编号不会提交
        flmc: '添加新节点',
        children: []
      }
      if (this.data.length !== 0) {
        // 获取第一个节点，新增节点的上级 与 该节点保持一致
        const firstNode = this.data[0]
        newChild.sjfl = firstNode.sjfl
        newChild.sjflmclj = firstNode.sjflmclj
      } else {
        newChild.sjfl = 0
        newChild.sjflmclj = ''
      }
      this.data.push(newChild)

      this.$nextTick(() => {
        // console.log(this.$refs.treectn01)
        // console.log(this.$refs.treectn01.scrollHeight)
        this.$refs.treectn01.scrollTop = this.$refs.treectn01.scrollHeight
      })
    },
    // 添加节点
    addNode (node, data) {
      /*
      if (!data.flbh) {
        this.$message.warning('请先进行保存，再继续添加子节点')
        return
      }
      */
      const newChild = {
        zt: '1',
        flbh: 'XN' + this.$utils.getUUID(), // 虚拟一个分类编号 该编号不会提交
        flmc: '添加新节点',
        sjfl: data.flbh,
        sjflmclj: data.flmc,
        zhid: data.zhid,
        cjrjs: data.cjrjs, // 后台会二次处理，取最小权限
        qxbz: data.qxbz, // 后台会二次处理，取最小权限
        children: []
      }
      if (data.children === null) {
        delete data.children
      }
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.push(newChild)
    },
    // 编辑节点
    editNode (node, data) {
      if (!data.zt || data.zt !== '1') {
        this.$set(data, 'zt', '2')
      }
      this.$nextTick(() => {
        document.querySelector('.input' + node.id).querySelector('.el-input__inner').focus()
      })
    },
    async beforeDelete (node, data) {
      if (data.flbh && data.flbh.constructor === Number) {
        const params = { flbh: data.flbh }
        // 检查是否可以删除（当分类下存在数据时不能删除）
        await this.checkExistsData(params)
        if (Number(this.dataCount) === 0) {
          this.deleteNode(node, data)
          this.dataCount = 1
        }
      } else {
        this.deleteNode(node, data)
      }
    },
    // 删除节点
    deleteNode (node, data) {
      // 如果是刚添加的分类 直接删除
      if (data.zt && data.zt === '1') {
        const parent = node.parent
        const children = parent.data.children || parent.data
        const index = children.findIndex(d => d.flbh === data.flbh)
        children.splice(index, 1)
      } else {
        this.$set(data, 'zt', '3')
        // 如果存在子节点  则递归删除子节点
        if (node.childNodes && node.childNodes.length > 0) {
          for (const index in node.childNodes) {
            const childNode = node.childNodes[index]
            this.deleteNode(childNode, childNode.data)
          }
        }
      }
    },
    // 确定
    submit () {
      // 先将树形结构 转成 数组结构
      this.list = []
      for (const index in this.data) {
        this.parseList(this.data[index])
      }
      // 只提交 增 删 改 的数据
      const ksyFlList = this.list.filter(data => data.zt && data.zt !== null)
      if (!ksyFlList || ksyFlList.length === 0) {
        this.$message.warning('没有数据被修改')
        return
      } else {
        ksyFlList.forEach(ksyFl => {
          // 通过这些虚拟的上级分类编号 找到上级分类在list的下标
          if (ksyFl.sjfl && ksyFl.sjfl.constructor === String && ksyFl.sjfl.indexOf('XN') !== -1) {
            const sjflIdx = ksyFlList.findIndex(a => a.flbh === ksyFl.sjfl)
            ksyFl.sjfl = 'XN' + sjflIdx
          }
        })
        ksyFlList.forEach(ksyFl => {
          if (ksyFl.flbh.constructor === String && ksyFl.flbh.indexOf('XN') !== -1) {
            ksyFl.flbh = null
          }
        })
      }
      const params = { flList: ksyFlList }
      const type = this.type
      let saveClassify
      switch (type) {
        case 'exam':
          saveClassify = saveExamClassify
          break
        case 'examPaper':
          saveClassify = saveExamPaperClassify
          break
        case 'questions':
          saveClassify = saveQuestionsClassify
          break
        default:
          this.$message.warning('我在哪？我是谁？')
          return
      }
      saveClassify(params).then(res => {
        this.$http.callback(res, () => {
          this.$message.success(res.msg)
          this.init()
        })
      })
    },
    cancel () {
      this.init()
      this.$emit('update:visible', false)
    },
    // 将树形结构转成成数组结构
    parseList (data) {
      if (data.children) {
        const obj = Object.assign({}, data)
        delete obj.children
        this.list.push(obj)
        if (data.children.length > 0) {
          for (const index in data.children) {
            this.parseList(data.children[index])
          }
        }
      } else {
        this.list.push(data)
      }
    },
    // 将数据转成成树形结构
    parseTree (list) {
      const temp = {}
      const tree = {}
      // 数组转 键值对
      list.forEach(flObj => {
        temp[flObj.flbh] = flObj
      })
      for (const flbh in temp) {
        const fl = temp[flbh]
        const sjflObj = temp[fl.sjfl]
        if (sjflObj) {
          if (!sjflObj.children) {
            sjflObj.children = []
          }
          sjflObj.children.push(fl)
        } else {
          tree[flbh] = fl
        }
      }
      this.data = Object.keys(tree).map(key => tree[key])
    },
    // 检查分类下是否存在数据
    async checkExistsData (params) {
      const type = this.type
      let checkExistsData
      switch (type) {
        case 'exam':
          checkExistsData = checkExamData
          break
        case 'examPaper':
          checkExistsData = checkExamPaperData
          break
        case 'questions':
          checkExistsData = checkQuestionsData
          break
        default:
          this.data = []
          return
      }
      await checkExistsData(params).then(res => {
        this.$http.callback(res, () => {
          // 返回结果
          this.dataCount = res.data
        })
      })
    },
    init () {
      const type = this.type
      let getClassifyList
      switch (type) {
        case 'exam':
          getClassifyList = examClassify
          break
        case 'examPaper':
          getClassifyList = examPaperClassify
          break
        case 'questions':
          getClassifyList = questionsClassify
          break
        default:
          this.data = []
          return
      }
      getClassifyList(null).then(res => {
        this.$http.callback(res, () => {
          // 生成分类树
          this.parseTree(res.data)
        })
      })
    }
  },
  created () {
    this.init()
  }
}
</script>
<style>
  .myInput input.el-input__inner {
    height:25px;
    line-height:25px
  }
</style>
<style lang="less" scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 20px;
  }
</style>
